import { getBrowserId } from '../utils/browserUtils';

// Smart API URL detection
const getApiBaseUrl = () => {
  // If REACT_APP_API_URL is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // If running on server IP, use server IP for API
  const hostname = window.location.hostname;
  if (hostname === '18.133.181.177' || hostname.includes('18.133.181.177')) {
    return 'http://18.133.181.177:3001/api';
  }
  
  // If running in production mode, use server IP
  if (process.env.NODE_ENV === 'production') {
    return 'http://18.133.181.177:3001/api';
  }
  
  // Default to localhost for local development
  return 'http://localhost:3001/api';
};

const API_BASE_URL = getApiBaseUrl();

const apiCall = async (endpoint, options = {}) => {
  const token = localStorage.getItem('temple_token');
  const browserId = getBrowserId();
  
  // Debug logging
  console.log('[API] Request:', endpoint, 'Browser ID:', browserId);

  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      'x-browser-id': browserId, // Add browser ID to all requests
      ...options.headers,
    },
    ...options,
  };

  if (options.body && typeof options.body === 'object') {
    config.body = JSON.stringify(options.body);
  }

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'API request failed');
    }

    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

export const authAPI = {
  login: (credentials) => 
    apiCall('/login', {
      method: 'POST',
      body: credentials,
    }),
  
  register: (userData) => 
    apiCall('/register', {
      method: 'POST',
      body: userData,
    }),
  
  getDashboard: () => 
    apiCall('/dashboard'),
};

export const offeringsAPI = {
  getOfferingTypes: () =>
    apiCall('/offerings/types'),

  addToBasket: (offeringData) => {
    const browserId = getBrowserId();
    return apiCall('/offerings/basket', {
      method: 'POST',
      body: { ...offeringData, browser_id: browserId },
    });
  },

  getBasket: () => {
    const browserId = getBrowserId();
    return apiCall(`/offerings/basket?browser_id=${browserId}`)
      .then(response => ({
        data: response.data?.items || response.data || []
      }));
  },

  updateBasketItem: (id, updateData) => {
    const browserId = getBrowserId();
    return apiCall(`/offerings/basket/${id}?browser_id=${browserId}`, {
      method: 'PUT',
      body: updateData,
    });
  },

  removeFromBasket: (id) => {
    const browserId = getBrowserId();
    return apiCall(`/offerings/basket/${id}?browser_id=${browserId}`, {
      method: 'DELETE',
    });
  },

  processPayment: (paymentData) =>
    apiCall('/offerings/process-payment', {
      method: 'POST',
      body: paymentData,
    }),

  clearBasket: () => {
    const browserId = getBrowserId();
    return apiCall(`/offerings/basket?browser_id=${browserId}`, {
      method: 'DELETE',
    });
  },

  checkout: (paymentData) => {
    const browserId = getBrowserId();
    return apiCall('/offerings/checkout', {
      method: 'POST',
      body: { ...paymentData, browser_id: browserId },
    });
  },

  getPayments: () =>
    apiCall('/offerings/payments'),
};

export default { authAPI, offeringsAPI };
